<template>
  <div class="expense-report">
    <div class="menu">
      <el-form :inline="true" >
      <div  class='sites-menu' @click="siteSelectVisible = true">
        站点筛选
        <i class="el-icon-caret-bottom"></i>
      </div>

      <el-form-item label="开始时间">
        <!--日期-->
        <el-date-picker
          v-model="start_date"
          type="date"
          class="start_date date-input"
          placeholder="开始日期">
        </el-date-picker>
        <!--时间-->
        <el-time-select
          v-model="start_time"
          class="start_time time-input"
          placeholder="请选择">
        </el-time-select>
      </el-form-item>
      <el-form-item label="结束时间">
        <!--日期-->
        <el-date-picker
          v-model="end_date"
          type="date"
          class="end_date date-input"
          placeholder="开始日期">
        </el-date-picker>
        <!--时间-->
        <el-time-select
          v-model="end_time"
          class="end_time time-input"
          placeholder="请选择">
        </el-time-select>
      </el-form-item>

      <el-form-item label="选择预设时间">
        <el-select placeholder="预设时间" v-model="time_range" class="time_range">
          <el-option label="自定义" value="custome"></el-option>
          <el-option label="最近一天" value="day"></el-option>
          <el-option label="最近一周" value="week"></el-option>
          <el-option label="最近一月" value="month"></el-option>
          <el-option label="最近一年" value="year"></el-option>
        </el-select>
      </el-form-item>

      <el-button plain type="primary" class="menu-btn" @click="getExpenseReport()">查询</el-button>

      <!--数据导出-->
      <!-- <download-excel 
        class = "export-excel-wrapper"
        :data = "historyData"
        :fields = "exportExportFileds"
        name = "历史数据表格.xls">
        <el-button plain type="primary" class="menu-btn">
          导出
        </el-button>
      </download-excel> -->

      <!--打印-->
      <el-button plain type="primary" class="menu-btn" popTitle="历史数据导出">
        打印
      </el-button>
    </el-form>
  </div>

  <!--内容页-->
  <div class="content" v-if="report">
    <electricity v-if="report['16']" :reportdata="report['16']"></electricity>
    <gas v-if="report['0']" :reportdata="report['0']"></gas>
  </div>


  <!-- 站点筛选--dialog -->
  <siteselect :show.sync="siteSelectVisible" v-on:siteSelectCompleted="siteSelectCompleted"></siteselect>

  </div>
</template>
<script>
import SiteSelect from "@components/SiteSelect"; // 站点筛选组件
import Electricity from "./ElectricityChart"; // 电的费用报表
import Gas from "./GasChart"; // 电的费用报表

import {getReportData} from "@api/report";
/**
 * 费用报表
 */
export default {
  name:"expense",
  data(){
    return {
      siteSelectVisible:false, // 站点筛选
      start_date:'', //开始日期
      end_date:'', // 结束日期
      start_time:'', // 开始时间
      end_time:'', // 结束时间
      time_range:"custome", // 时间范围下拉框

      selectSitesStr:"", // 选中的列表

      report:null, // 报表内容
    }
  },
  components:{
    siteselect: SiteSelect,
    electricity:Electricity, // 电
    gas:Gas, // 气
  },
  computed:{
    // 站点数据
    sites_config(){
      return this.$store.getters.getSitesConfigByPage();
      //  return this.$store.getters.sites_config;
    },
  },
  mounted(){
    // 初始化各项数据
    this.init();
  },
  methods:{
    // 初始化
    init(){
      this.getSelectedSites(); // 获取选中的站点列表
      // 格式化结束日期和时间
      let now=this.$moment(new Date());
      this.end_date= this.$moment(now).format('yyyy-MM-DD'); // 开时日期
      this.end_time=this.$moment(now).format('HH:mm'); // 开始时间

      let start_date=now.add(-1,"day");
      this.start_date= this.$moment(start_date).format('yyyy-MM-DD'); // 开时日期
      this.start_time=this.$moment(start_date).format('HH:mm'); // 开始时间

      // 获取费用
      this.getExpenseReport();
    },
    // 获取费用报表
    getExpenseReport(start_time,end_time){
      start_time=start_time||(this.start_date+" "+this.start_time);
      end_time=end_time||(this.end_date+" "+this.end_time);
      getReportData(start_time,end_time,this.selectSitesStr).then(res=>{
        this.report=res;
      })
    },
    // 获取选中的站点列表
    getSelectedSites(siteList){
      siteList=siteList||this.sites_config.siteList;
      //遍历全部站点，筛选出已被选中的站点
      //存放选中的数据
      var selectSiteList = [];
      for (let groupId in siteList) {
        let groupSites = siteList[groupId];
        for (let siteId in groupSites) {
          //拿到对应单个数据
          let siteItem = groupSites[siteId];
          if (siteItem.now == true) {
            selectSiteList.push(siteItem);
          }
        }
      }

      //得到选中站点的索引值
      var selectStr = "";
      for (var i = 0; i < selectSiteList.length; i++) {
        selectStr += selectSiteList[i].SiteNo + ",";
      }
      selectStr = selectStr.substr(0, selectStr.length - 1);
      // 保存选中的列表
      this.selectSitesStr = selectStr;
    },
    // 站点筛选完成
    siteSelectCompleted(sitelist){
      console.log(sitelist);
    }
  }
}
</script>
<style lang="scss">
.expense-report{
  /**菜单栏 */
  .menu{
    padding:10px 20px;
    background: #fff;

    /**站点删选按钮 */
    .sites-menu{
      position: relative;
      right: 10px;
      z-index: 10;
      color: #333;
      font-size: 14px;
      cursor: pointer;
      background: white;
      display: inline-block;
    }
    
    .el-form-item{
      margin-bottom: 0;
    }

    /**菜单栏按钮 */
    .menu-btn {
      height: 40px;
      margin-right: 10px;
      span {
        font-size: 16px;
        font-weight: 400;
      }
    }
    .date-input{
      width:135px;
      input {
        width:130px;
        padding-right: 15px;
      }
    }
    .time-input{
      width:100px;
      input {
        width:90px;
        padding-right: 10px;
      }
    }
    
    .time_range{
      width:120px;
    }
    .maxrowcount{
      input{
        width: 100px;
        padding:0 0 0 5px;
      }

    }

    .export-excel-wrapper{
      display: inline-block;
    }
  }
  /** 菜单栏结束 */
}
</style>